import { Pipe, PipeTransform } from '@angular/core';
import { UserCodeCacheService } from '@core/services/user-code-cache.service';
import { map } from 'rxjs/operators';

@Pipe({ name: 'bijlageTypeDescription' })
export class BijlageTypeDescriptionPipe implements PipeTransform {
  constructor(private readonly userCodeCacheService: UserCodeCacheService) {}

  transform = (value: string) =>
    this.userCodeCacheService.attachmentDocumentTypes$.pipe(
      map((documentTypes) => {
        const result = documentTypes.find((x) => x.name === value);
        return result ? result?.description : '';
      }),
    );
}
